// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"e94ca2a1","210":"9c1898eb","383":"d54bfa0a","453":"ce5ea167","525":"4115db7d","686":"6dd8e41a","917":"6416e4eb","997":"1f2e7d73"}[chunkId] + ".chunk.js";
};